export const FETCH_CUSTOM_FIELDS = '@@firedrum/FETCH_CUSTOM_FIELDS'
export const FETCHING_CUSTOM_FIELDS = '@@firedrum/FETCHING_CUSTOM_FIELDS'
export const SET_CUSTOM_FIELDS = '@@firedrum/SET_CUSTOM_FIELDS'
